<template>
  <div class="row" v-if="hasErrors" >
    <div class="col-md-12 error" v-for="error in errors">
        <p class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('entryForm', [ 'tabErrors']),
    ...mapGetters('entryFormApi', [ 'tabErrorMessages' ]),
    hasErrors() {
      return this.tabErrors(this.tab.id)
    },
    errors() {
      return this.tabErrorMessages(this.tab.type, this.tab.id);
    }
  }
}
</script>

<style scoped>

</style>